import { css } from '@emotion/react';
import { Divider, Paragraph, tokens } from '@flysas-tech/commercial-ui';
import { t } from 'i18n';
import { formatCurrency } from 'shared';

import { ExtrasPriceItem } from './types';

const styles = {
  container: css`
    display: flex;
    gap: ${tokens.dimension['space-6']};
    flex-direction: column;
  `,
  item: css`
    display: flex;
    justify-content: space-between;
  `,
  bold: css`
    font-weight: 700;
  `,
};
type Props = {
  pos: string;
  extrasItems: ExtrasPriceItem[] | undefined;
};
export const ExtrasCard = ({ extrasItems, pos }: Props) => {
  if (!extrasItems) return undefined;
  return (
    <>
      <div css={styles.container}>
        <Paragraph color="primary" size="paragraph-4" css={styles.bold}>
          {t('mmb:travelExtras')}
        </Paragraph>
        {extrasItems.map((priceGroup, index) => (
          <div key={`${index}-${priceGroup.label}`}>
            <div css={styles.item}>
              {priceGroup.label}
              <div css={styles.bold}>{formatCurrency(priceGroup.price, pos)}</div>
            </div>
          </div>
        ))}
      </div>
      <Divider direction="horizontal" variant={'subtle'} />
    </>
  );
};
